import { ProgressLoaderService } from '../../../core/services/progress-loader.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'pgh-loader-progress',
  templateUrl: './loader-progress.component.html',
  styleUrls: ['./loader-progress.component.css']
})
export class LoaderProgressComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: ProgressLoaderService) {}
  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe(value => {
      this.show = value.show;
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
